import React from 'react';

export interface AboutSection {
    id: string;
    title: string;
    content: React.ReactNode;
}

export const aboutSections: AboutSection[] = [
    {
        id: 'weald-taekwon-do',
        title: 'Weald Taekwon-Do',
        content: (
            <>
                <p>
                    Hello and welcome to Weald Taekwon-Do!
                </p>
                <br />
                <p>
                    We have classes in two different locations and cater for students from 8 years old and upwards.
                </p>
                <br />
                <div className="photo-block">
                    <img className="inline-photo-right" src="/images/general/kids-class-helmets.jpg" alt="Children's class with sparring helmets" />
                    <p>
                        Our classes will enable you to get fit, learn self defence and have fun. We even have some competitors and medalists from recent competitions.
                    </p>
                    <br />
                    <p>
                        Our Children's classes are designed to learn what we term as "Life-Skills" for the younger children, which covers areas like Anti-Bullying, Stranger Awareness, Self Control, Discipline, Persistance, Friendship, Achieving Goals, and all of these help to inspire Confidence, Courtesy and Respect.
                    </p>
                </div>
                <div className="photo-block">
                    <img className="inline-photo-left" src="/images/general/training-class-squats.jpg" alt="Training class practising together" />
                    <p>
                        Our more senior grades gain more technical experience and begin to develop power, co-ordination, learn set movements and self defence techniques which are tried and tested and age-appropriate.
                    </p>
                    <br />
                    <p>
                        The most senior grades and adults continue to develop controlled power, break boards, have more in-depth self defence and patterns, work on fitness and flexibility.
                    </p>
                </div>
                <div className="photo-block">
                    <img className="inline-photo-right" src="/images/general/class-demonstration.jpg" alt="Instructor demonstrating technique in class" />
                    <p>
                        We run our classes in a fun and controlled manner, ensuring the safety of all as a priority and ensure that development is done at the student's pace.
                    </p>
                </div>
                <div className="photo-block">
                    <img className="inline-photo-left" src="/images/general/aeta-grading.jpg" alt="Student receiving their new belt at a grading" />
                    <p>
                        Our gradings are run on a time spent/ability basis and the student is "invited" to go for the next grade once both the Instructor and student are in agreement.
                    </p>
                    <br />
                    <p>
                        The time to take to attain a Black Belt is a personal journey and we work hard to give all our students the best chance to achieve their goals.
                    </p>
                </div>
            </>
        ),
    },
    {
        id: 'itf-style',
        title: 'ITF Taekwon-Do',
        content: (
            <>
                <div className="photo-block">
                    <img className="inline-photo-right" src="/images/general/five-tenets.jpg" alt="The 5 Tenets of Taekwon-Do" />
                    <p>
                        "Taekwon-Do is a martial art to be used only for self defence and only in the cause of justice. The history of Korea contains not a single sample of its military forces being employed for the invasion of its neighbours or for any other purpose except national defence." - General Choi, Hong Hi - Founder of ITF Taekwon-Do.
                    </p>
                    <br />
                    <p>
                        Taekwon-Do is a modern form of self defence originating from Korea, founded by Grand Master General Choi, Hong Hi (1918-2002).
                    </p>
                </div>
                <div className="photo-block">
                    <img className="inline-photo-left" src="/images/general/seminar-demonstration.jpg" alt="Seminar demonstration with large group" />
                    <p>
                        He developed Taekwon-Do by researching other martial arts and by using modern scientific principles to design techniques that have maximum power and effectiveness.
                    </p>
                    <br />
                    <p>
                        ITF Taekwon-Do has grown in popularity since its inception and is now taught in nearly every country in the world. It is most famous for its spectacular and dynamic kicking techniques, although this has led to the misconception that Taekwon-Do is just a kicking art.
                    </p>
                </div>
                <div className="photo-block">
                    <img className="inline-photo-right" src="/images/general/respect-bowing.jpg" alt="Respect — Martial Arts teaches why not to fight" />
                    <p>
                        Taekwon-Do does indeed make extensive use of the legs, since the legs are longer and more powerful than the arms, but kicks make up only a small fraction of the total number of ITF Taekwon-Do techniques. There are also blocks, punches, thrusts and strikes with the hands or arms as well as basic throws and grappling.
                    </p>
                    <br />
                    <p>
                        The wide range of techniques caters for all types of situations, and students are taught to defend against single and multiple opponents, on foot, seated and prone, and against weapons such as sticks and knives.
                    </p>
                </div>
            </>
        ),
    },
    // {
    //     id: 'our-style',
    //     title: 'Our Style',
    //     content: (
    //         <p>
    //             Our club follows the traditional ITF (International Taekwon-Do Federation) style,
    //             maintaining the original techniques, patterns, and philosophy as developed by General Choi Hong Hi.
    //         </p>
    //     ),
    // },
    // {
    //     id: 'what-makes-us-different',
    //     title: 'What Makes Us Different',
    //     content: (
    //         <p>
    //             At our club, we believe in creating a supportive community where students of all ages and
    //             abilities can thrive. Our instructors are committed to helping each student reach their
    //             personal best, whether that's achieving their next belt, improving fitness, or developing
    //             self-confidence.
    //         </p>
    //     ),
    // },
    // {
    //     id: 'training-philosophy',
    //     title: 'Training Philosophy',
    //     content: (
    //         <p>
    //             We emphasize the five tenets of Taekwon-Do: Courtesy, Integrity, Perseverance,
    //             Self-Control, and Indomitable Spirit. These principles guide not just our training,
    //             but how we interact with each other and the wider community.
    //         </p>
    //     ),
    // },
];
